import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ColumnI, RowI } from '@bodyanalytics/data-models-ui';

/** Payload shapes emitted by `tableEvent`; local to this component, no external consumer today. */
interface GenericTableEventI {
  action: 'edit' | 'delete' | 'checkboxChange';
  rowData?: Record<string, unknown>;
  rowIndex?: number;
  rowId?: unknown;
  checked?: boolean;
}

@Component({
  selector: 'bodyanalytics-generic-table',
  templateUrl: './generic-table.component.html',
  styleUrls: ['./generic-table.component.scss'],
  imports: [DatePipe, MatTooltipModule],
})
export class GenericTableComponent {
  @Input()
  columns: ColumnI[] = [];
  @Input()
  rows: RowI[] = [];

  @Output() tableEvent = new EventEmitter<GenericTableEventI>();

  onColumnClick(column: ColumnI) {
    // Handle column click events (e.g., sorting)
  }

  onEditRow(row: RowI) {
    // Emit an event to notify the parent component about editing a row
    this.tableEvent.emit({ action: 'edit', rowData: row.data });
  }

  onDeleteRow(index: number) {
    // Remove the row from the rows array
    this.rows.splice(index, 1);
    // Emit an event to notify the parent component about the deletion
    this.tableEvent.emit({ action: 'delete', rowIndex: index });
  }
  onCheckboxChange(event: Event) {
    // Emit an event with the selected row's ID and checked state
    const target = event.target as HTMLInputElement;
    this.tableEvent.emit({ action: 'checkboxChange', rowId: target.value, checked: target.checked });
  }
}
